import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {HOAIRule} from "../api";


@Injectable()
@Pipe({name: 'sortHoaiRules'})
export class SortHoaiRulesPipe implements PipeTransform {
  transform(rules: HOAIRule[]): HOAIRule[] {
    return rules.sort((a, b) => {
      // sort by serviceType and then alphabetically by readableName
      if (a.serviceType === b.serviceType) {
        return a.readableName!.localeCompare(b.readableName!);
      }
      return b.serviceType!.localeCompare(a.serviceType!);
    });
  }
}
